import axios from 'axios';

import { handleError } from '@/shared/services/api';

export default {
  url(id) {
    if (id) {
      return `${window.api_url}/organization/complaints/${id}`;
    }
    return `${window.api_url}/organization/complaints`;
  },

  create(resource) {
    return axios.post(this.url(), { complaint: resource }).catch(handleError);
  },

  destroy(id) {
    return axios.delete(this.url(id)).catch(handleError);
  },

  get(id) {
    return axios.get(this.url(id)).catch(handleError);
  },

  index(filters, success) {
    return axios.get(this.url(), { params: filters }).then(success);
  },

  update(id, resource) {
    return axios.patch(this.url(id), { complaint: resource }).catch(handleError);
  },
};
